import {
  apiActionBuilder,
  apiRequestPayloadBuilder,
  ApiRequestPayloadBuilderOptions,
  ApiSuccessAction,
  HttpMethod,
} from "../api-builder";
import { StatsFilters } from "redux-store/slices/stats/interfaces";

export interface GetStatsMerchantsEventsDevicesByMerchantIdParams {
  merchantId: string;
  filters: {
    [statsFilter in StatsFilters]?: string | number;
  };
}
export interface GetStatsMerchantsEventsDevicesByMerchantIdResponseData {
  devicesCountPerEvent: {
    eventId: string;
    eventTitle: string;
    devicesSubscribedCount: number;
    devicesReachedCount: number;
    created: Date;
  }[];
}
export default apiActionBuilder<
  GetStatsMerchantsEventsDevicesByMerchantIdParams,
  ApiSuccessAction<GetStatsMerchantsEventsDevicesByMerchantIdResponseData>
>(
  "apis/stats/merchants/{merchantId}/events/devices/get",
  (
    params: GetStatsMerchantsEventsDevicesByMerchantIdParams,
    options?: ApiRequestPayloadBuilderOptions,
  ) => ({
    payload: apiRequestPayloadBuilder(
      {
        path: `/stats/merchants/${params.merchantId}/events/devices`,
        method: HttpMethod.GET,
        query: params.filters,
      },
      options,
      params,
    ),
  }),
);
